import React from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

const PurchaseFormSection = ({ headerText, numberOfRecipients, children }) => (
  <React.Fragment>
    {headerText ? (
      <div className="py2 mb3 md-pb0">
        <Heading bottomBorder className="text-semibold" size="md" tagName="h2">
          <FormattedMessage {...headerText} values={{ numberOfRecipients }} />
        </Heading>
      </div>
    ) : null}
    <div className="md-mt2 mb5 lg-mb6">{children}</div>
  </React.Fragment>
);

export default PurchaseFormSection;
